<template>
  <div id="app" class="flex flex-col min-h-screen">
    <Header />
    <main class="flex-grow">
      <router-view v-slot="{ Component }">
        <transition name="slide-fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <Footer @show-cookies="showCookies" />
    <CookieConsent ref="cookieConsent" />
    <ToastContainer ref="toastContainer" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import Header from './components/layout/Header.vue';
import Footer from './components/layout/Footer.vue';
import CookieConsent from './components/pages/CookieConsent.vue';
import ToastContainer from './components/ui/ToastContainer.vue';
import { setToastContainer } from './composables/useToast';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    CookieConsent,
    ToastContainer,
  },
  setup() {
    const cookieConsent = ref(null);
    const toastContainer = ref(null);

    const showCookies = () => {
      if (cookieConsent.value && typeof cookieConsent.value.open === 'function') {
        cookieConsent.value.open();
      }
    };

    onMounted(() => {
      // Registrar el ToastContainer para que los composables puedan usarlo
      if (toastContainer.value) {
        setToastContainer(toastContainer.value);
      }
    });

    return {
      cookieConsent,
      toastContainer,
      showCookies,
    };
  },
};
</script>
